export default __webpack_public_path__ + "images/4f05b8c2ddb9c75e3c7f693d497cae97.png";